import ReactEChartsCore from "echarts-for-react/lib/core";
import * as echarts from "echarts/core";

import { BarChart } from "echarts/charts";

import { GridComponent, TitleComponent, TooltipComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
import styles from "../styles/analyticsCharts.module.css";

const AnalyticsHorizontalBarChart = ({ title, labels, primaryData, secondaryData }: AnalyticsChartProps) => {
  echarts.use([BarChart, TitleComponent, TooltipComponent, GridComponent, CanvasRenderer]);

  //these are in the app.css, but I'm not sure how to apply css to these charts
  const blueLight = "#90D6E6";
  const blueMedium = "#0090BC";
  const blueDark = "#0D4D87";
  const gold = "#FCB415";
  const orangeLight = "#F6861F";
  const orangeMedium = "#F15523";
  const redLight = "#EE2B31";
  const redMedium = "#C02026";
  const redDark = "#8C1821";
  const lightGrey = "#e8e8e8";

  let percents = [] as number[];

  //how we calculate percents, temporary
  let totalPopulation = primaryData ? primaryData.reduce((partSum, a) => partSum + a, 0) : 0;
  if (secondaryData && secondaryData !== null) {
    totalPopulation += secondaryData.reduce((partSum, a) => partSum + a, 0);
  }
  //for now, calculate row total ( primaryData[n] + secondaryData[n])/totalPop
  if (primaryData) {
    for (let i = 0; i < primaryData.length; i++) {
      // percents[i] =
      //   Math.round((10000 * ((secondaryData ? secondaryData[i] : 0) + primaryData[i])) / totalPopulation) / 100;
      percents = primaryData.map((value, index) => {
        const total = (value + (secondaryData ? secondaryData[index] : 0));
        return totalPopulation > 0 ? Math.round((10000 * total) / totalPopulation) / 100 : 0;
      });
    }
  } else if (secondaryData) {
    for (let i = 0; i < secondaryData.length; i++) {
      // percents[i] =
      //   Math.round((10000 * ((primaryData ? primaryData[i] : 0) + secondaryData[i])) / totalPopulation) / 100;
      percents = secondaryData.map((value, index) => {
        const total = ((primaryData ? primaryData[index] : 0) + value);
        return totalPopulation > 0 ? Math.round((10000 * total) / totalPopulation) / 100 : 0;
      });
    }
  }
  let noZerosPrimary = [] as any[];
  let noZerosSecondary = [] as any[];
  if (primaryData) {
    noZerosPrimary = primaryData.map((a) => (a !== 0 ? a : ""));
  }
  if (secondaryData) {
    noZerosSecondary = secondaryData.map((b) => (b !== 0 ? b : ""));
  }

  const percentStrings = percents.map((a) => a.toString() + "%");
  const getOptions = () => ({
    yAxis: [
      {
        data: labels,
        axisLabel: {
          inside: true,
          color: blueDark,
          fontWeight: 500,
          fontSize: 11,
          fontFamily: "Inter",
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        z: 10,
      },
      {
        data: percentStrings,
        axisLabel: {
          inside: false,
          color: blueDark,
          fontWeight: 500,
          fontSize: 11,
          fontFamily: "Inter",
          borderRadius: 5,
          backgroundColor: lightGrey,
          padding: 6,
          width: 115,
          interval: 0,
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        z: 10,
      },
    ],
    xAxis: {
      type: "value",
      min: 0,
      max: totalPopulation,
      axisLine: {
        show: false,
      },
      splitLine: {
        show: false,
      },
      inverse: true,
      axisTick: {
        show: false,
      },
      axisLabel: {
        show: false,
      },
    },
    series: [
      {
        type: "bar",
        showBackground: true,
        stack: true,
        barWidth: 25,
        label: {
          show: true,
          formatter: "{c}",
          position: "inside",
        },
        backgroundStyle: {
          color: lightGrey, //getColor('gray-200'),
          borderRadius: 5,
        },
        itemStyle: {
          color: blueMedium, //getColor('primary'),
          borderRadius: 5,
        },
        data: noZerosPrimary,
      },
      {
        // left set of data bar, optional
        type: "bar",
        showBackground: true,
        stack: true,
        barWidth: 25,
        label: {
          show: true,
          formatter: "{c} ",
          position: "inside",
        },
        itemStyle: {
          color: blueLight, //getColor('primary'),
          borderRadius: 5,
        },
        data: noZerosSecondary,
      },
    ],
    grid: { right: "65px", left: "0", bottom: "0", top: "0" },
  });

  return (
    <div className={styles.chartWrapper}>
      <h2 className={styles.header}>{title} </h2>
      <ReactEChartsCore echarts={echarts} option={getOptions()} style={{ height: "10rem" }} />
    </div>
  );
};

export default AnalyticsHorizontalBarChart;
